/*! fullscreen.js */

/**
 * @type {object}
 */
const VENDORS = {
    "webkit": {
        element: "webkitFullscreenElement",
        enabled: "webkitFullscreenEnabled",
        exit: "webkitExitFullscreen",
        onchange: "webkitfullscreenchange",
        onerror: "webkitfullscreenerror",
        request: "webkitRequestFullscreen",
        status: "webkitIsFullScreen"
    },
    "moz": {
        element: "mozFullScreenElement",
        enabled: "mozFullScreenEnabled",
        exit: "mozCancelFullScreen",
        onchange: "mozfullscreenchange",
        onerror: "mozfullscreenerror",
        request: "mozRequestFullScreen",
        status: "mozFullScreen"
    },
    "ms": {
        element: "msFullscreenElement",
        enabled: "msFullscreenEnabled",
        exit: "msExitFullscreen",
        onchange: "MSfullscreenchange",
        onerror: "MSfullscreenerror",
        request: "msRequestFullscreen",
        status: "msFullscreen"
    },
    "default": {
        element: "fullscreenElement",
        enabled: "fullscreenEnabled",
        exit: "exitFullscreen",
        onchange: "fullscreenchange",
        onerror: "fullscreenerror",
        request: "requestFullscreen",
        status: "fullscreen"
    }
};

const VENDOR_PREFIX = getVendorPrefix();
const IS_SUPPORTED = VENDOR_PREFIX !== undefined;

class FullScreen {

    /**
     * @static
     * @param {Element} element
     */
    static requestFullScreen(element) {
        if (!IS_SUPPORTED) {
            return;
        }

        const method = VENDORS[VENDOR_PREFIX].request;
        element[method]();
    }

    /**
     * @static
     */
    static exitFullScreen() {
        if (!IS_SUPPORTED) {
            return;
        }

        const method = VENDORS[VENDOR_PREFIX].exit;
        this._getDocumentProperty(method)();
    }

    /**
     * @static
     * @returns {*}
     */
    static isEnabled() {
        if (!IS_SUPPORTED) {
            return false;
        }

        const property = VENDORS[VENDOR_PREFIX].enabled;
        return this._getDocumentProperty(property);
    }

    /**
     * @static
     * @returns {boolean}
     */
    static isSupported() {
        return IS_SUPPORTED;
    }

    /**
     * @static
     * @returns {boolean}
     */
    static isInFullScreen() {
        if (!IS_SUPPORTED) {
            return;
        }

        const property = VENDORS[VENDOR_PREFIX].status;
        return this._getDocumentProperty(property);
    }

    /**
     * @static
     * @returns {?Element}
     */
    static getFullScreenElement() {
        if (!IS_SUPPORTED) {
            return;
        }

        const property = VENDORS[VENDOR_PREFIX].element;
        return this._getDocumentProperty(property);
    }

    /**
     * @static
     * @returns {?string}
     */
    static getVendorPrefix() {
        return VENDOR_PREFIX;
    }

    /**
     * NOTE: Test framework won't allow the overwrite of read-only
     * document properties so we use this method to allow us to stub for testing
     * @private
     * @param {string} property
     * @returns {object}
     */
    static _getDocumentProperty(property) {
        return document[property];
    }
}

/**
 * @private
 * @returns {*}
 */
function getVendorPrefix() {
    if (document.fullscreenEnabled !== undefined) {
        return "default";
    }
    if (document.webkitFullscreenEnabled !== undefined) {
        return "webkit";
    }
    if (document.mozFullScreenEnabled !== undefined) {
        return "moz";
    }
    if (document.msFullscreenEnabled !== undefined) {
        return "ms";
    }
}

Object.assign(FullScreen, {
    vendorMap: VENDORS,
    fullscreenchange: IS_SUPPORTED && VENDORS[VENDOR_PREFIX].onchange,
    fullscreenerror: IS_SUPPORTED && VENDORS[VENDOR_PREFIX].onerror
});

export default FullScreen;
